/* Willow & Stone KIT SELECTOR (cart rebuild 2026-07-31).
 * Supersedes assets/truehone-gift-ladder.js — which owned a full client-side
 * cart state machine (clear + atomic re-add + multi-pass reconciler). That
 * whole class of logic is gone: tiers are server-side Shopify bundles, gifts
 * are bundle components, so the ONLY job left on the client is:
 *   1. write the selected card's variant id into the product form(s)
 *   2. repaint the price displays + card/unlock-bar selection state
 * The stock product-form.js owns the actual add and the drawer render.
 *
 * Scope guard (kept from the ladder build): only [name=id] inputs whose
 * current value is one of OUR tier variant ids are retargeted — a drawer
 * upsell / quick-add form must never be hijacked.
 */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-ws-kit-selector]');
    if (!root || root.__wsInit) return;
    root.__wsInit = true;

    var radios = Array.prototype.slice.call(root.querySelectorAll('input[data-th-tier]'));
    if (!radios.length) return;

    // Every id a tier card can point at, plus whatever the form starts with —
    // the containment set for the scope guard.
    var knownIds = {};
    radios.forEach(function (r) { if (r.value) knownIds[r.value] = true; });
    document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function (input) {
      if (input.value) knownIds[input.value] = true;
    });

    var unavailableNote = root.querySelector('[data-ws-unavailable-note]');

    function setFormsDisabled(disabled) {
      document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function (input) {
        if (!knownIds[input.value]) return;
        var form = input.form;
        if (!form) return;
        Array.prototype.forEach.call(form.elements, function (el) {
          if (el.type === 'submit') el.disabled = disabled;
        });
      });
      // sticky ATC button is form-associated via the form="" attribute and is
      // covered by form.elements above; nothing extra needed.
    }

    function apply(radio) {
      var tier = radio.getAttribute('data-th-tier');

      // card selection state
      root.querySelectorAll('[data-th-tier-card]').forEach(function (card) {
        card.classList.toggle('is-selected', card.getAttribute('data-th-tier-card') === tier);
      });

      // unlock bar: lit nodes <= tier, fill sweeps to the highest lit node
      var nodes = root.querySelectorAll('[data-th-unlock-node]');
      var maxIndex = 0;
      var sel = parseInt(tier, 10) || 1;
      nodes.forEach(function (node) {
        var req = parseInt(node.getAttribute('data-th-unlock-node'), 10) || 0;
        var lit = sel >= req;
        node.classList.toggle('is-lit', lit);
        if (lit && req > maxIndex) maxIndex = req;
      });
      var fill = root.querySelector('[data-th-unlock-fill]');
      if (fill) {
        var n = nodes.length;
        var pct = n > 1 ? ((maxIndex - 1) / (n - 1)) * 100 : maxIndex >= 1 ? 100 : 0;
        fill.style.width = Math.max(0, Math.min(100, pct)) + '%';
      }

      // pre-provisioning: a card with no variant disables the ATC instead of
      // silently no-oping
      if (!radio.value || radio.getAttribute('data-ws-unavailable') === 'true') {
        if (unavailableNote) unavailableNote.hidden = false;
        setFormsDisabled(true);
        return;
      }
      if (unavailableNote) unavailableNote.hidden = true;
      setFormsDisabled(false);

      // retarget the product form(s) — scope-guarded
      document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function (input) {
        if (knownIds[input.value]) input.value = radio.value;
      });
      knownIds[radio.value] = true;

      // repaint price displays (main price block + sticky ATC price)
      var money = radio.getAttribute('data-ws-price-money');
      if (money) {
        document
          .querySelectorAll('.product-page-price .price-item--regular, .sticky-atc__price .price-item--regular')
          .forEach(function (el) { el.textContent = money; });
      }
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) apply(radio);
      });
    });

    var checked = radios.filter(function (r) { return r.checked; })[0] || radios[0];
    apply(checked);
  }

  // bfcache restore can resurrect a stuck loading state on the ATC buttons
  // (stock product-form.js never sees the restore) — hard-reset it.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document
      .querySelectorAll('.atc-button, .product-form__submit, [id^="StickyAtcSubmitButton-"]')
      .forEach(function (b) {
        b.classList.remove('loading');
        b.removeAttribute('aria-disabled');
        b.disabled = false;
        var sp = b.querySelector('.loading-overlay__spinner');
        if (sp) sp.classList.add('hidden');
      });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
